<template>
    <div class="platform-tab">
        <div class="tabulation-title" :style="'color:' + titlesColor">
            <h5>
                {{ index }}.
                <span v-if="!newTitle">
                    Site web et plateformes
                </span>
                <span v-else>
                    {{newTitle}}
                </span>
            </h5>
        </div>

        <v-alert type="info"
                 class="mb-5 form-container mr-auto ml-auto"
                 border="right"
                 :color="primaryColor"
                 colored-border
                 v-if="helpDesc"
        >
            <div>{{helpDesc}}</div>
        </v-alert>

        <div class="form-container mr-auto ml-auto mt-3">
            <form-component-loader :fields="tabulationFields"></form-component-loader>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex"
import _ from "lodash"

import FormComponentLoader from "../FormComponentLoader.vue"

export default {
    name: "Platform",
    components: {FormComponentLoader},
    props: ['index', "newTitle", "helpDesc"],
    computed: {
        ...mapState('webFormStyle', ['titlesColor', 'fieldsColor', 'primaryColor']),
        ...mapGetters('web_form', ['hasField', 'getField', 'getFieldsFromTabulation']),
        tabulationFields() {
            return this.getFieldsFromTabulation('PLATFORM').sort((a, b) => a.order - b.order)
        }
    }
}
</script>